<router-outlet></router-outlet>

<app-live-toasts></app-live-toasts>